import { Card, CardContent } from "@/components/ui/card";

export const StatCard = ({ icon: Icon, label, value, sub, testId }) => (
  <Card className="shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-shadow duration-200" data-testid={testId}>
    <CardContent className="p-6">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-md bg-secondary flex items-center justify-center">
          <Icon className="h-5 w-5 text-primary" />
        </div>
        <p className="text-sm text-muted-foreground">{label}</p>
      </div>
      <p className="text-3xl font-serif font-semibold mt-4">{value}</p>
      {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
    </CardContent>
  </Card>
);
